import { PropsWithChildren, useContext, useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "../../context/auth";

export const UnAuthRoute = ({ children }: PropsWithChildren): JSX.Element => {
  const { signed, isLoading } = useContext(AuthContext)
  const mounted = useRef(false)

  useEffect(() => {
    mounted.current = true
  }, [])

  if (signed && !isLoading && !mounted.current) {
    console.log('oioi')
    return <Navigate to="/home" />
  }

  return children as unknown as JSX.Element;
};